<template>
  <span>{{ currency }}</span>
</template>

<script>
export default {
  name: "AppCurrency",
  data: () => ({
    currency: "руб." // "₽"
  })
};
</script>
